const MessagesEmpty = {
  components: {
    Adsense,
  },
  computed: {
    ...Vuex.mapState(['user']),
  },
  template: `
    <div>
      <Adsense unit="3423209573" />
      <div class="uk-grid uk-flex-middle uk-margin-medium-bottom">
        <div class="uk-width-auto@m uk-text-center">
          <img src="/assets/img/drawn/empty.svg" alt="Mensajes" />
        </div>
        <div class="uk-width-expand@m">
          <div class="uk-padding">
            <h3 class="uk-text-bold">Todavía no tienes ningún mensaje</h3>
            <p v-if="user.profile">
              Si estás buscando trabajo puedes
              <a href="/empleo/localidades/">consultar todas las ofertas disponibles</a>.
              <br/>
              Mientras te llegan los primeros mensajes descubre que ofertas vacantes se ajustan a tu perfil.
            </p>
            <p v-else>
              <br/>
              Mientras te llegan los primeros mensajes puedes              
              publicar una oferta de trabajo o pedir un presupuesto para el servicio que necesites.
              <router-link to="/empleo/nuevo" class="uk-button uk-button-dmtk uk-margin-top">
                Publica tu oferta
              </router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  `,
};
